import { Layout, Menu, Tag, Tooltip } from 'antd'
import {
  EditOutlined,
  ExportOutlined,
  FileTextOutlined,
  PictureOutlined,
  ScissorOutlined,
  UnorderedListOutlined,
  VideoCameraOutlined,
} from '@ant-design/icons'
import { Link, Outlet, useLocation } from 'react-router-dom'

const { Header, Sider, Content } = Layout

const PIPELINE_STAGES = [
  { key: '/', path: '/', icon: <ScissorOutlined />, label: '图片资产', enabled: true },
  { key: '/scenes', path: '/scenes', icon: <PictureOutlined />, label: 'AI场景', enabled: false },
  { key: '/content', path: '/content', icon: <EditOutlined />, label: '内容编辑', enabled: false },
  { key: '/details', path: '/details', icon: <FileTextOutlined />, label: '详情页', enabled: false },
  { key: '/video', path: '/video', icon: <VideoCameraOutlined />, label: '视频', enabled: false },
  { key: '/publish', path: '/publish', icon: <ExportOutlined />, label: '发布', enabled: false },
]

export default function AppLayout() {
  const location = useLocation()
  const selected =
    PIPELINE_STAGES.slice()
      .reverse()
      .find((s) => s.path !== '/' && location.pathname.startsWith(s.path))?.key ?? '/'

  return (
    <Layout className="app-shell">
      <Sider width={212} theme="dark" className="app-sider">
        <div className="brand">
          <div className="brand-title">Vistoera</div>
        </div>
        <Menu
          theme="dark"
          mode="inline"
          className="app-nav-menu"
          selectedKeys={[selected]}
          items={PIPELINE_STAGES.map((s) => ({
            key: s.key,
            icon: s.icon,
            disabled: !s.enabled,
            label: s.enabled ? (
              <Link to={s.path}>{s.label}</Link>
            ) : (
              <Tooltip title="下一阶段开放" placement="right">
                <span className="nav-item-soon">
                  <span>{s.label}</span>
                  <Tag className="nav-soon-tag">即将推出</Tag>
                </span>
              </Tooltip>
            ),
          }))}
        />
      </Sider>
      <Layout>
        <Header className="app-header">
          <div style={{ flex: 1 }} />
          <Link to="/jobs" className="header-jobs-link">
            <UnorderedListOutlined /> 任务
          </Link>
        </Header>
        <Content className="app-content">
          <Outlet />
        </Content>
      </Layout>
    </Layout>
  )
}
